import { render, staticRenderFns } from "./BenefitDecisionPanel.vue?vue&type=template&id=528f10b2&scoped=true"
import script from "./BenefitDecisionPanel.vue?vue&type=script&lang=js"
export * from "./BenefitDecisionPanel.vue?vue&type=script&lang=js"
import style0 from "./BenefitDecisionPanel.vue?vue&type=style&index=0&id=528f10b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f10b2",
  null
  
)

export default component.exports